export default {
      id: "ellipsis-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#ellipsis-usage",
      toString: function () {
        return this.url;
      }
    }